import React from 'react';
import cn from 'classnames';
import { SportTeam, TeamsSportEvent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { createPictureFactory, Picture, PictureData } from '@funtech-int/yango-shared';

import styles from './TeamsEventMeta.module.css';

interface TeamsEventMetaProps {
    sportEvent: TeamsSportEvent;
    size?: 'l' | 's';
    className?: string;
}

const logoFactory = createPictureFactory({
    fallback: {
        src: '96x96',
    },
});

export const TeamsEventMeta: React.FC<TeamsEventMetaProps> = ({
    sportEvent,
    size = 'l',
    className,
}) => {
    const { firstTeam, secondTeam, liveMeta } = sportEvent;
    const { firstTeamScore, secondTeamScore } = liveMeta || {};

    const large = size === 'l';
    const hasScores = firstTeamScore !== undefined && secondTeamScore !== undefined;
    const scoreStyle = cn(styles.score, large ? styles.largeScore : styles.smallScore);

    return (
        <div className={cn(styles.root, className, large ? styles.largeRoot : styles.smallRoot)}>
            <div className={styles.teams}>
                <TeamRow team={firstTeam} large={large} />
                <TeamRow team={secondTeam} large={large} />
            </div>
            {hasScores && (
                <div className={styles.scores}>
                    <span className={scoreStyle}>{firstTeamScore.result}</span>
                    <span className={scoreStyle}>{secondTeamScore.result}</span>
                </div>
            )}
        </div>
    );
};

interface TeamRowProps {
    team: SportTeam;
    large: boolean;
}

const TeamRow: React.FC<TeamRowProps> = (props) => {
    const { team, large } = props;
    const logoOrig = team.logo?.avatarsUrl || undefined;

    let logo: PictureData | undefined;

    if (logoOrig) {
        logo = logoFactory({
            fallbackUrl: logoOrig,
        });
    }

    return (
        <div className={styles.team}>
            {logo && (
                <Picture
                    src={logo.img.src}
                    className={cn(
                        styles.teamLogo,
                        large ? styles.largeTeamLogo : styles.smallTeamLogo
                    )}
                />
            )}
            <span
                className={cn(styles.teamName, large ? styles.largeTeamName : styles.smallTeamName)}
            >
                {team.name}
            </span>
        </div>
    );
};
